/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useState } from "react";
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails, Modal } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStyles } from "./styles";
import { ImageData } from '../../interfaces/Images';
import { axiosHelperWithToken } from "utils/axios";
import { showNotification } from "store/slices/snackbar/snackbarSlice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate, programmaticDownload } from "utils";
import DownloadIcon from '@mui/icons-material/Download';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import Button from '../../components/button';
import { getPatientId } from "store/selectors/userSelector";
import {
    FacebookShareButton,
    TwitterShareButton
} from "react-share";

const Exams = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [imageData, setImageData] = useState({} as any);
    const [expanded, setExpanded] = useState('');
    const [viewImage, setViewImage] = useState({ images: null, index: -1, image: null }) as any;
    const patientId = useSelector(getPatientId);

    useEffect(() => {
        const axios = axiosHelperWithToken();
        axios.get(`/Patient/images/${patientId}`).then((response) => {
            setImageData(response.data);
            setExpanded(Object.keys(response.data)[0]);
        }).catch(() => {
            dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
        });
    }, [dispatch, patientId]);

    const handleClose = () => {
        setViewImage(null);
    }
    const prevNextFunction = (event: any) => {
        if (event.keyCode === 27) {
            // Escape key press
            setViewImage(null);
        }
        else if (event.keyCode === 37) {
            // Left Arrow key press
            setCurrentImage(viewImage?.index - 1);
        }
        else if (event.keyCode === 39) {
            // Right Arrow key press
            setCurrentImage(viewImage?.index + 1);

        }
    };
    const previousImage = () => {
        setCurrentImage(viewImage?.index - 1);
    }
    const nextImage = () => {
        setCurrentImage(viewImage?.index + 1);
    }
    const setCurrentImage = (index: number) => {
        if (index < viewImage?.images?.length && index > -1) {
            setViewImage({ ...viewImage, index, image: viewImage?.images[index] })
        }
        else {
            setViewImage({ ...viewImage, index: 0, image: viewImage?.images[0] })
        }
    }
    const isVideoMedia = (mediaUri: string) => {
        if (mediaUri) {
            const videoExt = mediaUri.substring(mediaUri.lastIndexOf('.') + 1, mediaUri.length).toLowerCase()
            const isVideo = videoExt === "avi" || videoExt === "mp4"
            return isVideo;
        }
        else return false;
    }
    return (
        <Grid container className={classes.container}>
            <Typography component="h1" variant="h5" color="inherit" gutterBottom style={{
                color: "black",
                fontSize: "35px",
                lineHeight: "50px",
                paddingBottom: '40px',
                width: '100%',
                textAlign: 'center'
            }}>
                Gallery
            </Typography>
            <Modal
                open={viewImage?.image}
                onClose={handleClose}
                onKeyDown={prevNextFunction}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <div className={classes.modalBody}>
                    <div className={classes.imageContainer}>
                        <Button action={previousImage} styles={{ padding: '10px' }} text={'<<'}></Button>
                        {isVideoMedia(viewImage?.image?.url) ?
                            <video width="100%" height="auto" controls>
                                <source src={viewImage?.image?.url.toLowerCase().replace(".avi", ".mp4")} type="video/mp4" />
                                <track src="" kind="captions" label="english_captions"></track>
                            </video> :
                            <img src={viewImage?.image?.url} alt={'ultrasound'} width={'100%'} />
                        }
                        <Button action={nextImage} styles={{ padding: '10px' }} text={'>>'}></Button>
                    </div>
                </div>
            </Modal>
            <Grid xs={10} className={classes.galleryContainer}>
                {Object.keys(imageData).map((key, index) => {
                    return (
                        <Accordion key={index}
                            expanded={expanded === key}
                            onChange={() => setExpanded(key)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography>Images {formatDate(key)}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid xs={12} container>
                                    <Grid xs={12}>
                                        <Button
                                            text={'Download all'}
                                            styles={{ marginBottom: '15px', float: 'right' }}
                                            action={() => {
                                                imageData[key].forEach((image: ImageData) => programmaticDownload(image.url, `${image.mediaId}.jpg`))
                                            }}
                                        />
                                    </Grid>

                                    {imageData[key].map((image: ImageData, index: number) => {
                                        return (
                                            <Grid key={index} xs={4} className={classes.imageItem}>
                                                {isVideoMedia(image.url) ?
                                                    <video width="100%" height="auto" controls onClick={() => setViewImage({ images: imageData[key], index: index, image })}>
                                                        <source src={image.url.toLowerCase().replace(".avi", ".mp4")} type="video/mp4" />
                                                        <track src="" kind="captions" label="english_captions"></track>
                                                    </video> :
                                                    <img src={image.url} alt={'ultrasound'} width={'100%'} onClick={() => setViewImage({ images: imageData[key], index: index, image })} />
                                                }
                                                <DownloadIcon style={{ cursor: 'pointer' }} onClick={() => {
                                                    programmaticDownload(image.url, `${image.mediaId}.jpg`)
                                                }} />
                                                <FacebookShareButton quote={''} hashtag={''} url={image.url}>
                                                    <FacebookIcon style={{ cursor: 'pointer', height: '28px', marginLeft: '8px' }} />
                                                </FacebookShareButton>
                                                <TwitterShareButton title={''} url={image.url}>
                                                    <TwitterIcon style={{ cursor: 'pointer', height: '28px', marginLeft: '8px' }} />
                                                </TwitterShareButton>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </Grid>
        </Grid>
    );
}

export default Exams
